import React, { useContext, useEffect, useState } from 'react';
import "./PolymatchResults.css";
import Flag from 'react-world-flags';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import { UserContext } from '../UserContext';
import Footer from "../Footer";
import TeacherNav from '../Navbars/TeacherNav';
import { useNavigate, useSearchParams } from 'react-router-dom';
import polymatchImage from '../../assets/Polymatch.png';
import axios from 'axios';

const getRankIcon = (rank) => {
  if (rank === 1 || rank === 2 || rank === 3) {
    return <span className="rank-trophy">🏆</span>;
  }
  if (rank === 4 || rank === 5) {
    return <span className="rank-medal">🏅</span>;
  }
  return null; // 6th rank ke baad kuch show nahi hoga
};

const COMPETITION_CONFIG = {
  islamic: {
    endpoint: '/students_results_Isl',
    congrats: 'PolyMatch 2025 - Global Islamic Knowledge Competition held on 14 March 2025.',
    heading: 'Global Islamic Knowledge Competition',
    year: '2025',
  },
  english: {
    endpoint: '/students_results_eng',
    congrats: 'PolyMatch 2025 - Global English Linguistic Competition held on 24th January 2025.',
    heading: 'Global English Linguistic Competition',
    year: '2025',
  },
  mentalmath: {
    endpoint: '/students_results',
    congrats: 'PolyMatch 2025 - Global Mental Math Competition',
    heading: 'Global Mental Math Competition',
    year: '2025',
  },
  science: {
    endpoint: '/students_results_science',
    congrats: 'PolyMatch 2025 - Science Competition',
    heading: 'Science Competition',
    year: '2025',
  },
  coding: {
    endpoint: '/students_results_coding',
    congrats: 'PolyMatch 2025 - Coding Competition',
    heading: 'Coding Competition',
    year: '2025',
  },
  graphicdesigning: {
    endpoint: '/students_results_graphicdesigning',
    congrats: 'PolyMatch 2025 - Graphic Designing Competition',
    heading: 'Graphic Designing Competition',
    year: '2025',
  },
};

// Responsive styles for the results page
const responsiveStyles = `
.responsive-age-selector {
  width: 100%;
  max-width: 616px;
  height: 69.44px;
  margin: 0 auto 32px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 55.44px;
  border-bottom: 4.03px solid #E0E0E0;
  box-sizing: border-box;
  gap: 16px;
  opacity: 1;
  overflow-x: auto;
  padding: 0 8px;
}

.responsive-age-btn {
  min-width: 140px;
  width: 189.28px;
  height: 56px;
  border: none;
  outline: none;
  border-radius: 43.68px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: none;
  opacity: 1;
  margin: 0;
  padding: 0;
  flex-shrink: 0;
}
.responsive-age-btn.selected {
  background: #FDC019;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.responsive-age-btn span {
  min-width: 90px;
  width: 118.72px;
  height: 23px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 700;
  font-style: bold;
  font-size: 18px;
  line-height: 22.18px;
  letter-spacing: 0;
  text-align: center;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  opacity: 1;
}

@media (max-width: 700px) and (min-width: 300px) {
  .responsive-age-selector,
  .responsive-age-selector * {
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
    overflow-x: hidden !important;
  }
  .responsive-age-selector {
    height: 40px;
    gap: 2px;
    padding: 0;
    display: flex;
  }
  .responsive-age-btn {
    flex: 1 1 0;
    min-width: 60px !important;
    width: 0 !important;
    height: 36px;
    border-radius: 14px;
    margin: 0 !important;
    padding: 0 4px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }
  .responsive-age-btn span {
    font-size: 12px;
    min-width: 30px;
    width: 50px;
    height: auto;
    padding: 0 4px;
    white-space: normal;
    line-height: 1.1;
    overflow: hidden !important;
    display: block;
  }
  .PolymatchResultsText {
    font-size: 14px !important;
    padding: 0 2px;
  }
  .results-table-container {
    overflow-x: hidden;
    width: 100vw;
    max-width: 100vw;
    min-width: unset;
    box-sizing: border-box;
  }
  .results-table {
    width: 100vw;
    min-width: unset;
    table-layout: fixed;
    font-size: 7px;
    border-collapse: collapse;
    box-sizing: border-box;
  }
  .results-table th, .results-table td {
    padding: 1px 1px;
    word-break: break-word;
    white-space: normal;
    text-align: center;
    vertical-align: middle;
    font-size: 7px;
    box-sizing: border-box;
  }
  .results-table th:nth-child(1), .results-table td:nth-child(1) { width: 14.3%; }
  .results-table th:nth-child(2), .results-table td:nth-child(2) { width: 14.3%; }
  .results-table th:nth-child(3), .results-table td:nth-child(3) { width: 14.3%; }
  .results-table th:nth-child(4), .results-table td:nth-child(4) { width: 14.3%; }
  .results-table th:nth-child(5), .results-table td:nth-child(5) { width: 14.3%; }
  .results-table th:nth-child(6), .results-table td:nth-child(6) { width: 14.3%; }
  .results-table th:nth-child(7), .results-table td:nth-child(7) { width: 14.3%; white-space: normal; word-break: break-word; }
  .responsive-polymatch-img {
    width: 200px !important;
    height: 200px !important;
    display: block;
    margin-left: auto;
    margin-right: auto;
    opacity: 1 !important;
  }
}

@media (max-width: 700px) {
  .responsive-polymatch-img {
    width: 250px !important;
    height: 250px !important;
    display: block;
    margin-left: auto;
    margin-right: auto;
    opacity: 1 !important;
  }
}

@media (max-width: 1000px) {
  .responsive-stay-tuned {
    width: 96vw !important;
    max-width: 600px !important;
    font-size: 5vw !important;
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center !important;
    height: auto !important;
    padding: 0 8px;
    word-break: break-word;
  }
}
@media (max-width: 700px) {
  .responsive-stay-tuned {
    width: 99vw !important;
    max-width: 350px !important;
    font-size: 4.5vw !important;
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center !important;
    height: auto !important;
    padding: 0 2px;
    word-break: break-word;
  }
}

@media (max-width: 360px) and (min-width: 300px) {
  .responsive-stay-tuned {
    width: 99vw !important;
    max-width: 99vw !important;
    font-size: 12px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center !important;
    height: auto !important;
    padding: 0 1px;
    word-break: break-word;
  }
}

@media (max-width: 600px) {
  .results-table th, .results-table td {
    max-width: 50px;
  }
}

@media (max-width: 400px) {
  .results-table th, .results-table td {
    max-width: 36px;
    font-size: 8px;
  }
}

@media (max-width: 500px) and (min-width: 300px) {
  .results-table-container {
    overflow-x: visible;
    width: 100vw;
    max-width: 100vw;
  }
  .results-table {
    width: 100vw;
    min-width: unset;
    table-layout: fixed;
    font-size: 7px;
    border-collapse: collapse;
  }
  .results-table th, .results-table td {
    padding: 1px 1px;
    word-break: break-word;
    white-space: normal;
    text-align: center;
    vertical-align: middle;
    font-size: 7px;
  }
  .results-table th:nth-child(1), .results-table td:nth-child(1) { width: 14%; }
  .results-table th:nth-child(2), .results-table td:nth-child(2) { width: 14%; }
  .results-table th:nth-child(3), .results-table td:nth-child(3) { width: 14%; }
  .results-table th:nth-child(4), .results-table td:nth-child(4) { width: 14%; }
  .results-table th:nth-child(5), .results-table td:nth-child(5) { width: 14%; }
  .results-table th:nth-child(6), .results-table td:nth-child(6) { width: 14%; }
  .results-table th:nth-child(7), .results-table td:nth-child(7) { width: 16%; }
}

@media (min-width: 700px) {
  .responsive-age-selector {
    width: 100%;
    max-width: 600px;
    min-width: 0;
    margin: 0 auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 0;
    box-sizing: border-box;
  }
  .responsive-age-btn {
    width: 120px;
    min-width: 80px;
    flex: none;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
}
`;

// Helper function to extract year from result data
const extractYearFromResult = (result) => {
  // Try to extract year from displayName first
  if (result.displayName) {
    const yearMatch = result.displayName.match(/\b(20\d{2})\b/);
    if (yearMatch) {
      return parseInt(yearMatch[1]);
    }
  }
  
  // If no year found in displayName, try to extract from other date fields
  // This is a fallback - you might need to adjust based on your actual data structure
  if (result.date) {
    const date = new Date(result.date);
    if (!isNaN(date.getTime())) {
      return date.getFullYear();
    }
  }
  
  // Default to current year if no year can be extracted
  return new Date().getFullYear();
};

// Helper function to generate age groups from API response
const generateAgeGroupsFromResults = (results) => {
  if (!results || !Array.isArray(results)) return [];
  
  return results.map((result, index) => ({
    id: `ageGroup_${index}`,
    label: result.displayName, // Use displayName directly without "Age " prefix
    displayName: result.displayName
  }));
};

// Helper function to find age group by display name
const findAgeGroupByDisplayName = (ageGroups, displayName) => {
  return ageGroups.find(group => group.displayName === displayName);
};

const PolymatchResults = ({ competition, competitionHeading, year = "2025" }) => {
  const { isAdmin, isTeacher, isStudent, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const [aAgesResults, setAgesResults] = useState([]);
  const [ageGroups, setAgeGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedAgeGroup, setSelectedAgeGroup] = useState(null);

  // Get year and competition ID from query parameters or props
  const selectedYear = searchParams.get('year') || year;
  const competitionId = searchParams.get('competitionId');
  const competitionName = searchParams.get('competitionName') || competitionHeading;
  
  // Determine competition type from props or query param
  const competitionType = competition || searchParams.get('competition') || 'mentalmath';
  // Allow all competitions including the new ones
  const allowedCompetitions = ['mentalmath', 'english', 'islamic', 'science', 'coding', 'graphicdesigning'];
  const isAllowed = allowedCompetitions.includes(competitionType);
  const config = isAllowed ? COMPETITION_CONFIG[competitionType] : COMPETITION_CONFIG['mentalmath'];

  // Inject responsive styles
  useEffect(() => {
    if (!document.getElementById('responsive-polymatch-styles')) {
      const style = document.createElement('style');
      style.id = 'responsive-polymatch-styles';
      style.innerHTML = responsiveStyles;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    if (!isAllowed) {
      setAgesResults([]);
      setAgeGroups([]);
      setError('No results available for this competition.');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    
    // Use the new unified endpoint with competition ID if available, otherwise fall back to old endpoint
    const apiEndpoint = competitionId 
      ? `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/students_results/${competitionId}`
      : `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}${config.endpoint}`;
    
    axios.get(apiEndpoint)
      .then((res) => {
        const allResults = res.data?.data || [];
        // If using competition ID, we don't need to filter by year as the API should return correct data
        // If using old endpoint, filter by year
        const filteredResults = competitionId 
          ? allResults 
          : allResults.filter(result => {
              const resultYear = extractYearFromResult(result);
              return resultYear === parseInt(selectedYear);
            });
        
        // Generate age groups from the API response
        const dynamicAgeGroups = generateAgeGroupsFromResults(filteredResults);
        console.log("dynamicAgeGroups",dynamicAgeGroups);
        setAgeGroups(dynamicAgeGroups);
        setAgesResults(filteredResults);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch results. Please try again later.');
        setLoading(false);
      });
  }, [competitionType, isAllowed, selectedYear, competitionId]);

  const determineUserRole = (usertype) => {
    if (usertype === 'Student') return 'Student';
    if (usertype === 'Teacher') return 'Teacher';
    if (usertype === 'Admin') return 'Admin';
    return 'guest';
  };

  const onLogin = (usertype) => {
    setUserRole(determineUserRole(usertype));
  };

  function onLogout() {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    setUserRole('guest');
    navigate('/');
  }

  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;

  return (
    <>
      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}

      {/* Restored Hero/Header Section */}
      <section className="results-hero-section">
        <div className="results-hero-content">
          <h1 className="results-hero-heading">
            <span className="congratulations-text">Congratulations to All</span><br />
            <span className="participants-text">Participants and Winners!</span>
          </h1>
          <p className="results-hero-paragraph">
            View the complete list of winners, toppers, and participants who showcased their knowledge and dedication during the {competitionHeading || config.heading} (PolyMatch {selectedYear})
          </p>
        </div>
        <div className="results-hero-images">
          {/* You can add your images here if needed, e.g.:
          <img src={presult1} alt="Result 1" className="presult1-image" />
          <img src={presult2} alt="Result 2" className="presult2-image" />
          */}
        </div>
      </section>

      <div className='PolymatchBg'>
        <div className='PolymatchSection_1'>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <img src={polymatchImage} alt="image" className="responsive-polymatch-img" />
          </div>
          {/* 4 lines of space after the image */}
          <div style={{ height: '32px' }}></div>
          <div style={{ height: '32px' }}></div>
          <div style={{ height: '32px' }}></div>
          <div style={{ height: '32px' }}></div>
          {!isAllowed && (
            <p style={{ color: 'red', fontWeight: 'bold' }}>No results available for this competition.</p>
          )}
          {isAllowed && ageGroups.length > 0 && (
            <div className="responsive-age-selector">
              {ageGroups.map((group) => {
                const isSelected = selectedAgeGroup === group.id || (!selectedAgeGroup && ageGroups[0].id === group.id);
                return (
                  <button
                    key={group.id}
                    className={`responsive-age-btn${isSelected ? ' selected' : ''}`}
                    onClick={() => setSelectedAgeGroup(group.id)}
                  >
                    <span>{group.label}</span>
                  </button>
                );
              })}
            </div>
          )}
          <br />
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px' }}><h3>Loading Results...</h3></div>
          ) : error ? (
            <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}><h3>{error}</h3></div>
          ) : (
            isAllowed && (() => {
              const filteredResults = aAgesResults?.filter(data => {
                // Find the age group that matches this data's display name
                const matchingAgeGroup = findAgeGroupByDisplayName(ageGroups, data.displayName);
                if (!matchingAgeGroup) return false;
                
                // Only show the selected age group, or the first by default
                const isSelectedGroup = selectedAgeGroup ? matchingAgeGroup.id === selectedAgeGroup : matchingAgeGroup.id === ageGroups[0]?.id;
                // Only show if it has participants data
                const hasParticipants = data?.participants && data.participants.length > 0;
                return isSelectedGroup && hasParticipants;
              });

              // If no results found for the selected age group, show a message
              if (!filteredResults || filteredResults.length === 0) {
                const currentAgeGroup = selectedAgeGroup || ageGroups[0]?.id;
                const ageGroupLabel = ageGroups.find(group => group.id === currentAgeGroup)?.label || 'Selected Age Group';
                return (
                  <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
                    <h3>No results available for {ageGroupLabel}</h3>
                    <p>Results will be published soon. Please check back later.</p>
                  </div>
                );
              }

              return filteredResults.map((data, index) => {
                const matchingAgeGroup = findAgeGroupByDisplayName(ageGroups, data.displayName);
                return (
                  <div key={index}>
                    <div
                      className='PolymatchResultsText'
                      id={matchingAgeGroup?.id}
                      style={{
                        color: '#CB1D5A',
                        fontFamily: 'Comic Sans MS, Comic Sans, cursive',
                        fontWeight: 550,
                        fontStyle: 'bold',
                        fontSize: '38px',
                        lineHeight: '100%',
                        letterSpacing: 0,
                        textAlign: 'center',
                        margin: '0 auto',
                        marginBottom: '12px',
                      }}
                    >
                    PolyMatch {selectedYear} <br />
                    {competitionName || config.heading} Results {data?.displayName}
                    </div>
                    <br />
                    <div className="results-table-container responsive-results-table">
                      <table className="results-table">
                        <thead>
                          <tr>
                            <th>Rank</th>
                            <th>Name</th>
                            <th>Parent Name</th>
                            <th>Country</th>
                            <th>Total Score</th>
                            <th>Correct Answers</th>
                            <th>Incorrect / Unanswered</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.participants?.map((item, idx) => (
                            <tr key={idx}>
                              {/* <td>{item?.rank}</td> */}
                              <td>
  {getRankIcon(item?.rank)}
  {item?.rank}
</td>
                              <td>{`${item?.firstName || ''} ${item?.lastName || ''}`}</td>
                              <td>{item?.parentName}</td>
                              <td>{item?.country}</td>
                              <td>{item?.total}</td>
                              <td>{item?.correctAnswers}</td>
                              <td>{item?.incorrectAnswers}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <br />
                  </div>
                );
              });
            })()
          )}
        </div>
      </div>
      <br />
      {/* Add 4 empty lines above */}
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <div
        className="responsive-stay-tuned"
        style={{
          width: '1040px',
          height: '56px',
          marginLeft: '77px',
          opacity: 1,
          fontFamily: 'Comic Sans MS, Comic Sans, cursive',
          fontWeight: 700,
          fontStyle: 'bold',
          fontSize: '40px',
          lineHeight: '100%',
          letterSpacing: 0,
          textAlign: 'center',
          color: 'purple',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        STAY TUNED FOR MORE COMPETITIONS IN {selectedYear}
      </div>
      {/* Add 4 empty lines below */}
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <div style={{ height: '32px' }}></div>
      <Footer />
    </>
  );
};

export default PolymatchResults;